import { render, staticRenderFns } from "./ElDrawer.vue?vue&type=template&id=48d266c0"
import script from "./ElDrawer.vue?vue&type=script&lang=js"
export * from "./ElDrawer.vue?vue&type=script&lang=js"
import style0 from "./ElDrawer.vue?vue&type=style&index=0&id=48d266c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports